import React from 'react';
import NewsletterBox from '../NewsletterBox/NewsletterBox';
import { getRecentPosts } from '../../../../../data/blogPosts';
import { categories } from '../../../../../data/categories';
import { Link } from 'react-router-dom';
import './BlogSidebar.css';

const BlogSidebar = () => {
  const recentPosts = getRecentPosts(5);

  return (
    <aside className="blog-sidebar">
      {/* Newsletter */}
      <NewsletterBox />

      {/* Popular Posts */}
      <div className="sidebar-widget">
        <h3 className="sidebar-widget-title">Recent Posts</h3>
        <div className="sidebar-posts">
          {recentPosts.map(post => (
            <Link 
              key={post.id}
              to={`/blog/${post.slug}`}
              className="sidebar-post"
            >
              <img 
                src={post.featuredImage} 
                alt={post.title}
                className="sidebar-post-image"
              />
              <div className="sidebar-post-content">
                <h4 className="sidebar-post-title">{post.title}</h4>
                <span className="sidebar-post-date">
                  {new Date(post.publishDate).toLocaleDateString('en-US', { 
                    month: 'short', 
                    day: 'numeric' 
                  })}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Categories */}
      <div className="sidebar-widget">
        <h3 className="sidebar-widget-title">Categories</h3>
        <ul className="sidebar-categories">
          {categories.slice(1).map(category => (
            <li key={category.id} className="sidebar-category">
              <span className="sidebar-category-icon">{category.icon}</span>
              <span className="sidebar-category-name">{category.name}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* CTA Box */}
      <div className="sidebar-cta">
        <h3 className="sidebar-cta-title">Need Funding Now?</h3>
        <p className="sidebar-cta-text">Get a free consultation with our experts</p>
        <Link to="/contactform" className="sidebar-cta-button">
          Contact Us
        </Link>
      </div>
    </aside>
  );
};

export default BlogSidebar;